// Batch quantity input validation
// Extends the default quantity-input behavior to enforce batch quantities

document.addEventListener('DOMContentLoaded', function() {
  // Find all quantity inputs with a step attribute of 6
  const batchInputs = document.querySelectorAll('quantity-input input[step="6"]');
  
  batchInputs.forEach(input => {
    const batchSize = parseInt(input.getAttribute('step')) || 6;
    const quantityInputElement = input.closest('quantity-input');
    
    // Only validate on blur (when user manually types a value)
    input.addEventListener('blur', function(e) {
      validateBatchQuantity(this, batchSize);
    });
    
    // Validate on input for manual typing only (not for button clicks)
    let isManualInput = false;
    input.addEventListener('input', function(e) {
      // Remove non-numeric characters except for empty string
      if (this.value !== '' && !/^\d+$/.test(this.value)) {
        this.value = this.value.replace(/\D/g, '');
      }
      isManualInput = true;
    });
    
    // Don't interfere with button clicks - let the native stepUp/stepDown handle it
    input.addEventListener('change', function(e) {
      // Only validate if it was manual input, not a button click
      if (isManualInput) {
        validateBatchQuantity(this, batchSize);
      }
      isManualInput = false;
    });
  });
  
  function validateBatchQuantity(input, batchSize) {
    let value = parseInt(input.value);
    
    // Handle empty or NaN
    if (isNaN(value)) {
      input.value = 0;
      return;
    }
    
    // If value is 0, that's allowed (no purchase)
    if (value === 0) {
      return;
    }
    
    // Round to nearest batch
    const remainder = value % batchSize;
    if (remainder !== 0) {
      // Round to nearest multiple of batch size
      if (remainder < batchSize / 2) {
        value = value - remainder;
      } else {
        value = value + (batchSize - remainder);
      }
      
      // Ensure minimum is 0
      if (value < 0) {
        value = 0;
      }
      
      // Only update if the value changed
      if (parseInt(input.value) !== value) {
        input.value = value;
        
        // Trigger change event to update cart
        const changeEvent = new Event('change', { bubbles: true });
        input.dispatchEvent(changeEvent);
      }
    }
  }
});
